import React, { ComponentPropsWithoutRef, PropsWithChildren } from "react";

interface PillContainerProps
  extends PropsWithChildren<ComponentPropsWithoutRef<"div">> {
  children?: React.ReactNode;
  data: Array<{
    id: string;
    label: string;
  }>;
  selected?: string | number;
  title: string;
  change: (filter: string) => void;
}

interface PillProps
  extends PropsWithChildren<ComponentPropsWithoutRef<"span">> {
  children?: React.ReactNode;
  text: string | number;
  selected?: boolean;
}

const PillFilter = (props: PillContainerProps) => {
  return (
    <div className="flex gap-x-3 text-sm items-center">
      <span className="font-semibold text-gray-400">{props.title + ":"}</span>
      {props.data.map((datum, index) => (
        <Pill
          key={datum.id}
          text={datum.label}
          selected={props.selected === datum.id || props.selected === index}
          onClick={() =>
            props.change(props.selected === datum.id ? '' : datum.id)
          }
        />
      ))}
    </div>
  );
};

const Pill = (props: PillProps) => {
  const classes = props.selected
    ? "bg-admin-black text-white"
    : "bg-gray-100 text-black";

  return (
    <span
      className={`rounded-2xl text-xs font-semibold px-2 py-1 cursor-pointer transition-all ${classes} hover:bg-admin-black hover:text-white`}
      onClick={props.onClick}
    >
      {props.text}
    </span>
  );
};

export default PillFilter;
